import { Box } from '@mui/material';
import { RiZoomInLine, RiZoomOutLine } from '@remixicon/react';

import { AgButton } from 'src/components/ui';
import '@react-pdf-viewer/core/lib/styles/index.css'; // Core styles

type ZoomControlsProps = { currentScale: number; handleZoomChange: (scale: number) => void };

export function ZoomControlsMinified({ currentScale, handleZoomChange }: ZoomControlsProps) {
  return (
    <Box sx={{ display: 'flex' }}>
      <AgButton
        variant="ghost"
        size="icon-sm"
        shape="circle"
        onPress={() => handleZoomChange(currentScale - 0.2)}
        isDisabled={currentScale <= 0.2}
      >
        <RiZoomOutLine size={20} />
      </AgButton>
      <AgButton variant="ghost" size="icon-sm" shape="circle" onPress={() => handleZoomChange(currentScale + 0.2)}>
        <RiZoomInLine size={20} />
      </AgButton>
    </Box>
  );
}
